/**
 * Tres Commas campaign picker of the Traffic link dialog — lists
 * GET /tres-commas/campaigns (all pages). Rendered only once the Tres Commas tile
 * is picked, so no other tile ever requests it.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo, type FC } from 'react';

import { SearchableSelect } from '@/components/ui';
import { useTresCommasCampaigns } from '@/hooks';

import { tresCommasCampaignOptions } from './tres-commas-campaign-options';

interface TresCommasCampaignSelectProps {
  value: string;
  onChange: (campaignId: string) => void;
  disabled: boolean;
}

export const TresCommasCampaignSelect: FC<TresCommasCampaignSelectProps> = ({ value, onChange, disabled }) => {
  const campaigns = useTresCommasCampaigns();
  const options = useMemo(
    () => tresCommasCampaignOptions(campaigns.data, value),
    [campaigns.data, value],
  );
  return (
    <div className="space-y-1.5">
      <span className="text-sm font-medium">Tres Commas campaign</span>
      <SearchableSelect
        options={options}
        value={value.trim()}
        onChange={(id) => onChange(String(id))}
        placeholder={campaigns.isLoading ? 'Loading Tres Commas campaigns…' : 'Select a Tres Commas campaign'}
        searchPlaceholder="Search name or id…"
        disabled={disabled || campaigns.isLoading}
      />
      {campaigns.isError ? (
        <p className="text-xs text-destructive">Could not load the Tres Commas campaigns.</p>
      ) : null}
    </div>
  );
};
